import { render, staticRenderFns } from "./EditEventStep5.vue?vue&type=template&id=47464d06&scoped=true&"
import script from "./EditEventStep5.vue?vue&type=script&lang=js&"
export * from "./EditEventStep5.vue?vue&type=script&lang=js&"
import style0 from "./EditEventStep5.vue?vue&type=style&index=0&id=47464d06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47464d06",
  null
  
)

export default component.exports